/**
 * Created by User on 11/10/2016.
 */
var MggpPlugin = require('mggp-player').Plugin;
function MggpPluginVodChannels(player, config) {
  MggpPlugin.apply(this, arguments);

  var CONTENT_TYPE_VOD = 'vod';
  var CONTENT_TYPE_M_CHANNEL = 'm_ch';
  var CONTENT_TYPE_TV_LINEAR = 'tv_linear';

  var DISABLED = 'disabled';
  var CURRENT_PROGRAM_ABSENT = 'currentProgramAbsent';
  var OBJECT_ID_ABSENT = 'onjectIdAbsent';
  var ON_AIR = 'onAir';
  var CATCHUP = 'catchup';
  var TIMESHIFT = 'timeshift';
  var ERROR = 'error';
  var CHANNEL_STATE = 'interactiveChannel:channelState';
  var CURRENT_PLAYING_PROGRAM = 'interactiveChannel:currentPlayingProgram';
  var CURRENT_PROGRAM_TIME = 'interactiveChannel:currentPlayingTime';
  var CURRENT_PROGRAM_DURATION = 'interactiveChannel:currentProgramDuration';
  var EVENT_RESET_PLUGIN = 'interactiveChannel:reset';
  var FORCED_START_TIME = 'interactiveChannel:startTime';
  var CURRENT_PROGRAMS_LIST_UPDATED = 'epg:currentProgramListUpdated';

  var self = this;
  var state = DISABLED;
  var currentChannel = null;
  var originalVodChannelVideoInfo = null;
  var prevState = void 0;
  var lastProgram = null;
  var programVideoInfo = null;
  var waitingPlayingProgram = null;
  var currentShowedAdType = null;
  var isMChannel = false;
  var currentVideoInfo = null;

  self.player.registerProperty(CHANNEL_STATE, DISABLED, true);
  self.player.registerProperty(CURRENT_PLAYING_PROGRAM, null, true);
  self.player.registerProperty(CURRENT_PROGRAM_TIME, null, true);
  self.player.registerProperty(CURRENT_PROGRAM_DURATION, null, true);
  self.player.registerProperty(FORCED_START_TIME, null, true);

  self.player.on(EVENT_RESET_PLUGIN, onReset);
  self.player.on("ad:external:adComplete", onAdComplete);
  self.player.on("ad:external:memberStartedPlaying", onMemberStartedPlaying);

  this.dispose = function () {
    self.player.off('property:epg:currentChannel', onCurrentChannelChanged);
    self.player.off('epg:currentProgramChanged', onCurrentProgramChanged);
    self.player.off('vodChannel:playProgram', onPlayVodProgram);
    self.player.off('vodChannel:backOnAir', onBackOnAir);
    self.player.off('vodChannel:seek', onSeek);
    self.player.off('property:state', onPlayerStateChange);
    self.player.off('epg:channelSwitch', onChannelSwitch);
    self.player.off('player:timeUpdate', onTimeUpdate);

    setState(DISABLED);
    currentChannel = null;
    waitingPlayingProgram = null;
    lastProgram = null;
    currentVideoInfo = null;
  };

  this.load = function (src, videoInfo, options) {
    if (!originalVodChannelVideoInfo && videoInfo && !videoInfo.src.length) {
      return;
    }
    if (videoInfo === originalVodChannelVideoInfo) {
      return;
    }
    if (videoInfo) {
      if (originalVodChannelVideoInfo && compareContentType(videoInfo, CONTENT_TYPE_VOD)) {
        return;
      }

      isMChannel = compareContentType(videoInfo, CONTENT_TYPE_M_CHANNEL);

      if ((isMChannel || compareContentType(videoInfo, CONTENT_TYPE_TV_LINEAR))
        && (!originalVodChannelVideoInfo || originalVodChannelVideoInfo.video_id !== videoInfo.video_id)) {
        //videoInfo.src = '';
        originalVodChannelVideoInfo = videoInfo;
        programVideoInfo = null;
        waitingPlayingProgram = null;
        self.player.on('property:state', onPlayerStateChange);
        self.player.on('player:timeUpdate', onTimeUpdate);
        self.player.on('vodChannel:playProgram', onPlayVodProgram);
        self.player.on('vodChannel:backOnAir', onBackOnAir);
        self.player.on('vodChannel:seek', onSeek);
        self.player.on('epg:channelSwitch', onChannelSwitch);

        if(isMChannel) {
          self.player.on('epg:currentProgramChanged', onCurrentProgramChanged);
        }

        if(self.player.get(FORCED_START_TIME) > 0) {
          self.player.on(CURRENT_PROGRAMS_LIST_UPDATED, needForceProgramStart);
        }

        var isStopVideoStubLoading = false;
        var channel = self.player.get('epg:currentChannel');
        if (channel) {
          var isEpg2 = Boolean(self.player.get('epg2:api'));
          onCurrentChannelChanged({ data: channel });

          if (isEpg2) {
            if (isMChannel && channel.currentProgram && channel.currentProgram.objectId) {
              isStopVideoStubLoading = true;
            } else {
              // continue video stub loading, because there is no m-channel's program
              setState(DISABLED);
            }
          }
        } else {
          self.player.on('property:epg:currentChannel', onCurrentChannelChanged);
        }
        return !isStopVideoStubLoading;
      } else if (originalVodChannelVideoInfo && videoInfo && originalVodChannelVideoInfo.video_id === videoInfo.video_id) {
        return;
      }
    }

    if (originalVodChannelVideoInfo) {
      setState(DISABLED);
      originalVodChannelVideoInfo = null;
    }
    self.player.off('property:epg:currentChannel', onCurrentChannelChanged);
    self.player.off('property:state', onPlayerStateChange);
    self.player.off('player:timeUpdate', onTimeUpdate);
  };

  function onReset() {
    state = DISABLED;
    currentChannel = null;
    originalVodChannelVideoInfo = null;
    prevState = void 0;
    lastProgram = null;
    currentVideoInfo = null;
  }

  function needForceProgramStart(event) {
    //MHP-2009
    if(currentChannel && self.player.get(FORCED_START_TIME) > 0) {

      const position = self.player.get(FORCED_START_TIME);
      let target = currentChannel.programs.find(
          (program) => program.startTimestamp <= position && program.endTimestamp > position);

      //Если програмы не загружены - подождать.
      if (currentChannel.programs.length > 1) {
        self.player.set(FORCED_START_TIME, null);
      }

      if (target) {
        self.player.off(CURRENT_PROGRAMS_LIST_UPDATED, needForceProgramStart);
        self.player.set(CURRENT_PLAYING_PROGRAM, target, true);
        self.player.set(CURRENT_PROGRAM_DURATION, target.duration, true);
        setState(CATCHUP);
        loadVodProgram(target.objectId, false, position - target.startTimestamp, true);

        return true;
      } else {
        //Если програмы загружены но нужная не найдена то упасть в эфир
        if(currentChannel.currentProgram) {
          onBackOnAir();
        }
        return false;
      }
    }

    return false;
  }

  function onCurrentChannelChanged(event) {
    currentShowedAdType = null;
    waitingPlayingProgram = null;

    currentChannel = event.data;
    let currentPlayingProgramSet = false;
    lastProgram = null;
    if (currentChannel) {
      self.player.off('property:epg:currentChannel', onCurrentChannelChanged);

      if (currentChannel.isLocked) {
        return;
      }
    }

    if (self.player.get(FORCED_START_TIME) && needForceProgramStart()) {
      return;
    }

    if (!self.player.get(FORCED_START_TIME) && currentChannel && currentChannel.type === 'vodChannel') {
      if (currentChannel.currentProgram) {
        currentPlayingProgramSet = true;
        onCurrentProgramChanged({ data: currentChannel.currentProgram }, true);
        self.player.set(CURRENT_PLAYING_PROGRAM, currentChannel.currentProgram, true);
        self.player.set(CURRENT_PROGRAM_DURATION, currentChannel.currentProgram.duration, true);
      }
    } else {
      setState(DISABLED);
    }
    /*if (!currentPlayingProgramSet) {
      self.player.set(CURRENT_PLAYING_PROGRAM, null);
    }*/
  }

  function onCurrentProgramChanged(event, forceLoading) {
    var currentProgram = event.data;
    var currentPlayingProgram = self.player.get(CURRENT_PLAYING_PROGRAM); //MHP-2283
    if (lastProgram && currentProgram === lastProgram || currentProgram === currentPlayingProgram) {
      return;
    }

    //MHP-2009: Нужно придержать програму в эфире пока мы не загрузим полное EPG и не поймем что делать
    if(self.player.get(FORCED_START_TIME)) return;

    if (currentProgram && currentProgram.channel && currentChannel && currentProgram.channel.id === currentChannel.id) {
      if (currentProgram.channel.type !== 'vodChannel') {
        return;
      }
      if (state !== CATCHUP || forceLoading) {
        if (state !== TIMESHIFT || forceLoading) {
          // ON_AIR.
          if (currentProgram.objectId && currentProgram.objectId > 0) {
            if (forceLoading || !currentVideoInfo) {
              self.player.set(CURRENT_PLAYING_PROGRAM, currentProgram);
              self.player.set(CURRENT_PROGRAM_DURATION, currentProgram.duration);
              loadVodProgram(currentProgram.objectId, true, void 0, true);
            } else {
              // if state === ON_AIR and object is still playing (buffering, epg is unsynchronized)
              // continue the object playing and set state to CATCHUP
              setState(CATCHUP);
            }
          } else {
            setState(OBJECT_ID_ABSENT);
          }
        } else {
          //if there is TIMESHIFT
          if (currentPlayingProgram) {
            setState(currentPlayingProgram.state === 1 ? TIMESHIFT : CATCHUP);
            // loadVodProgram(currentPlayingProgram.objectId, false, self.player.get('position'), self.player.get('state') != 2);
          }
        }
      } else if (currentVideoInfo?.video_id === currentProgram.objectId) {
        // state === CATCHUP
        // if we are already playing the 'currentProgram' object, set the state to TIMESHIFT
        setState(TIMESHIFT);
      }
      lastProgram = currentProgram;
    }
  }

  function onChannelSwitch(event) {
    currentVideoInfo = null;
    originalVodChannelVideoInfo = null;

    if (!('type' in event.data)) {
      // if event.data is {id: <channel_id>}
      const getChannelById = self.player.get('epg:getChannelById');
      if (typeof getChannelById === 'function') {
        const channel = getChannelById(event.data.id);
        if (channel) {
          event.data = channel;
        }
      }
    }

    if (currentChannel && event.data && currentChannel.id !== event.data.id) {
      if (
        event.data.type === undefined ||
        event.data.type === "regularChannel" ||
        event.data.type === "dvrChannel" ||
        event.data.isLocked
      ) {
        setState(DISABLED);
        self.player.set(CURRENT_PLAYING_PROGRAM, null);
        self.dispose();
        onReset();
      } // MHP-1900
    }
  }

  function onMemberStartedPlaying(event) {
    if(event.data) currentShowedAdType = event.data.type;
  }

  function onAdComplete(event) {
    currentShowedAdType = null;
    if (!waitingPlayingProgram) return;
    //MHP-1849: Поскольку после постролла может быть преролл то нужно немного подождать и возможно пойти на второй круг :(
    setTimeout(function () {
      playProgram(waitingPlayingProgram.info,
          waitingPlayingProgram.onAir,
          waitingPlayingProgram.start,
          waitingPlayingProgram.autoPlay
      )
    }, 300);
  }

  function playProgram(videoInfo, onAirProgram, timeToStart, autoPlay) {
    if (videoInfo?.video_id === currentVideoInfo?.video_id) {
      return;
    }

    //MHP-1849: Не отображается postroll при использовании video state: "COMPLETE"
    if(currentShowedAdType === 'postroll' || currentShowedAdType ===  'preroll') {
      waitingPlayingProgram = {info: videoInfo, onAir: onAirProgram, start: timeToStart, autoPlay: autoPlay};
      return;
    }

    waitingPlayingProgram = null;

    if (videoInfo && videoInfo.src && originalVodChannelVideoInfo) {
      var options = {};
      var startTime = 0;
      var offset = 0;
      var cookieOptions = self.player.config.checkDefaultOptions(videoInfo);
      var defaultAudioTrack = cookieOptions ? getAudioTrackLangFromId(cookieOptions.defaultAudioTrack, videoInfo) : getAudioTrackLangFromId(self.player.get('audioTrack'), videoInfo);
      var defaultSubtitles = cookieOptions ? cookieOptions.defaultSubtitles : self.player.get('subtitles');
      var defaultQuality = cookieOptions ? cookieOptions.defaultQuality : self.player.get('quality');
      var currentPlayingProgram = self.player.get(CURRENT_PLAYING_PROGRAM);
      if (onAirProgram) {
        if (currentChannel && currentChannel.currentProgram) {
          if (timeToStart > 0) {
            startTime = timeToStart;
            setState(TIMESHIFT);
          } else {
            offset = self.player.get('epg:timeOffset');
            startTime = Math.round((new Date().getTime() / 1000 - currentChannel.currentProgram.startTimestamp) + offset);
            if (startTime < 0) {
              startTime = 0;
            }
            setState(ON_AIR);
          }
          self.player.set('src', videoInfo.src);

          options = {
            autoplay: autoPlay,
            startSeconds: startTime,
            defaultAudioTrack: defaultAudioTrack,
            defaultSubtitles: defaultSubtitles,
            defaultQuality: defaultQuality
          };

          getGroupedObject(options, currentPlayingProgram, videoInfo);
          loadVideo(videoInfo.src, videoInfo, options);
        } else {
          setState(CURRENT_PROGRAM_ABSENT);
        }
      } else {
        if(currentChannel &&
            currentChannel.currentProgram &&
            currentChannel.currentProgram.objectId === videoInfo.video_id) {
          setState(TIMESHIFT); // MHP-2228: п.3 [Mch] Catchup skin, але в правильній точці з es
        } else {
          setState(CATCHUP);
        }

        videoInfo.next = '';
        videoInfo.prev = '';

        options = {
          autoplay: autoPlay,
          startSeconds: timeToStart || .1,
          defaultAudioTrack: defaultAudioTrack,
          defaultSubtitles: defaultSubtitles,
          defaultQuality: defaultQuality
        };

        getGroupedObject(options, currentPlayingProgram, videoInfo);
        loadVideo(null, videoInfo, options);
      }
    } else {
      self.player.stop();
      setState(CATCHUP);
    }
  }

  function getGroupedObject(pOptions, pProgram, pVideoInfo) {
    if(!pVideoInfo.content_type.includes(CONTENT_TYPE_M_CHANNEL)) return;

    pOptions.objectId = pProgram.objectId;
    pOptions.startTimestamp = pProgram.startTimestamp;
    pOptions.endTimestamp = pProgram.endTimestamp;
    pOptions.disableAfter = !Boolean(pProgram.groupedPrograms);
    pOptions.disableBefore =  !Boolean(pProgram.groupedPrograms);
    pOptions.groupedPrograms = pProgram.groupedPrograms || {};

    pOptions.getStream = function (pId, pCallback) {
      self.player.config.getStream(pId, function (response) {
        pCallback(self.player.config.getStreamFromData(response));
      }, isMChannel ? 5000 : 0)
    }
  }

  function onPlayVodProgram(event) {
    if (event.data.objectId === -1) {
      return;
    }

    if (currentShowedAdType != null && programVideoInfo &&
        programVideoInfo.video_id !== event.data.objectId
    ) {
      currentShowedAdType = null;
      waitingPlayingProgram = null;

      self.player.stop();
    }

    self.player.set(CURRENT_PLAYING_PROGRAM, event.data);
    self.player.set(CURRENT_PROGRAM_DURATION, event.data.duration);
    if (event.data.state === 1) { // is current program
      if (compareContentType(originalVodChannelVideoInfo, CONTENT_TYPE_M_CHANNEL)) {
        loadVodProgram(event.data.objectId, true, 1, true);
      } else {
        onBackOnAir();
        return;
      }

    } else {
      loadVodProgram(event.data.objectId, false, void 0, true);
    }
  }

  function onBackOnAir(event) {
    if(currentShowedAdType) {
      self.player.stop();
      currentShowedAdType = waitingPlayingProgram = programVideoInfo = null;
    }

    if (compareContentType(originalVodChannelVideoInfo, CONTENT_TYPE_M_CHANNEL)
        && currentChannel && currentChannel.currentProgram && currentChannel.currentProgram.objectId > 0) {

      self.player.set(CURRENT_PLAYING_PROGRAM, currentChannel.currentProgram);
      self.player.set(CURRENT_PROGRAM_DURATION, currentChannel.currentProgram.duration);
      loadVodProgram(currentChannel.currentProgram.objectId, true, void 0, true);
    } else {
      self.player.set(CURRENT_PLAYING_PROGRAM, currentChannel.currentProgram);
      loadVodProgram(originalVodChannelVideoInfo.video_id, true, void 0, true);
    }
  }

  function onSeek(event) {
    if (currentChannel && currentChannel.currentProgram) {
      var currentProgramTime = self.player.get('epg:currentProgramTime');
      var position;
      /*if (event.data >= currentProgramTime) {   //MHP-360
        setState(ON_AIR);
        if (Math.abs(self.player.get('position') - currentProgramTime) >= 2) {
          position = currentProgramTime;
          self.player.seekTo(currentProgramTime);
          self.player.play();
        }
      } else {*/
      setState(TIMESHIFT);
      position = event.data;
      self.player.seekTo(event.data);
      //}
      self.player.set('position', position);
      self.player.set(CURRENT_PROGRAM_TIME, position);
    }
  }

  function loadVideo(src, videoInfo, options) {
    currentVideoInfo = videoInfo;
    self.player.stop();
    self.player.load(src, videoInfo, options);
  }

  function loadVodProgram(objectId, onAirProgram, startTime, autoPlay) {
    if (
      programVideoInfo &&
      programVideoInfo.video_id === objectId &&
      programVideoInfo.content_type !== 'tv_linear_vod' &&
      player.getPlayableElement() // check that player still has playing vendor. If not, here will be null, that means that player has stopped and cleared up the resources
    ) {
      if (autoPlay && self.player.get('state') !== 1) {
        self.player.play();
      }
      if (startTime !== undefined || onAirProgram && state !== ON_AIR) {
        onSeek({ data: startTime || self.player.get('epg:currentProgramTime') });
      } else if (!onAirProgram && startTime === undefined) {
        setState(CATCHUP);
        self.player.seekTo(0.1);
      }
      if (onAirProgram) {
        if (startTime !== undefined) {
          setState(TIMESHIFT);
        } else {
          setState(ON_AIR);
        }
      }
    } else if (self.player.config && typeof self.player.config.getStream === 'function') {
      self.player.config.getStream(objectId, function (response) {
        programVideoInfo = self.player.config.getStreamFromData(response);
        if (programVideoInfo) {
          currentVideoInfo = null;
          programVideoInfo = modifyStreamForRequiredSubs(programVideoInfo);
          //programVideoInfo.advert_url = '';
          //programVideoInfo.advert_data = '';
          if (programVideoInfo.src && programVideoInfo.src.indexOf('//') !== -1) {
            programVideoInfo.src = programVideoInfo.src.substring(programVideoInfo.src.indexOf('//'));
          }
          if (self.player.config.drm && self.player.config.supportedDrmType === 'fairplay') {
            programVideoInfo.src = programVideoInfo.src.replace(/\/a\/\d+/, '');
            if (self.player.config.device && self.player.config.device.os) {
              if (programVideoInfo.drm_type === 'fairplay') {
                var os = self.player.config.device.os;
                if (os.major > 10 || (os.major === 10 && os.minor >= 14)) {
                  programVideoInfo.bitrates = []; // MHP-597
                }
              }
            }
          }

          playProgram(programVideoInfo, onAirProgram, startTime, autoPlay);
        } else {
          onError('internalError', 'internalError', 'self.player.config.getStreamFromData couldn\'t get the stream');
        }
      }, isMChannel ? 5000 : 0);
    }

    function onError(type, code, message) {
      self.player.emit('mediaError', {
        name: self.constructor.name,
        type: type,
        code: code,
        message: message,
        fatal: true
      });
    }
  }

  function onPlayerStateChange(event) {
    if (state === ON_AIR || state === CATCHUP || state === TIMESHIFT) {
      if (event.data == 2) {
        if (state === ON_AIR) {
          setState(TIMESHIFT);
        }
      }

      if (event.data === 0) {
        //MHP-1617 Back on air if rich contend ended
        if(compareContentType(originalVodChannelVideoInfo, CONTENT_TYPE_TV_LINEAR)) {
          onBackOnAir();
          return;
        }

        var nextProgram = currentChannel.getNextProgram(self.player.get(CURRENT_PLAYING_PROGRAM));
        if (nextProgram && nextProgram.objectId > 0) {
          self.player.set(CURRENT_PLAYING_PROGRAM, nextProgram);
          self.player.set(CURRENT_PROGRAM_DURATION, nextProgram.duration);
          if (nextProgram.state === 1) { // is current program
            loadVodProgram(currentChannel.currentProgram.objectId, true, 1, true); // reset to start time live M-channel
          } else {
            loadVodProgram(nextProgram.objectId, false, void 0, true);
          }
        } else {
          var startTime = void 0;
          var currentPlayingProgram = self.player.get(CURRENT_PLAYING_PROGRAM);
          if(!currentPlayingProgram) return; //MHP-1900
          if (currentPlayingProgram.endTimestamp <= currentChannel.currentProgram.startTimestamp) {
            startTime = 0;
          }

          if(currentChannel.currentProgram.objectId > 0) {
            self.player.set(CURRENT_PLAYING_PROGRAM, currentChannel.currentProgram);
            loadVodProgram(currentChannel.currentProgram.objectId, true, startTime, true);
          } else {
            onBackOnAir();
          }


        }
      }

      prevState = event.data;
    }
  }

  function onTimeUpdate() {
    if (currentChannel && currentChannel.currentProgram && currentChannel.type === 'vodChannel') {
      self.player.set(CURRENT_PROGRAM_TIME, self.player.get('position'));
    }
  }

  function setState(pState) {
    if (currentChannel && currentChannel.type === 'regularChannel' && pState === TIMESHIFT) {
      return;
    }
    if (state !== pState) {
      state = pState;
      var valueToSet = [DISABLED, ERROR, OBJECT_ID_ABSENT].includes(state) ? null : state;
      self.player.set(CHANNEL_STATE, valueToSet);
    }
  }

  function getAudioTrackLangFromId(id, videoInfo) {
    var result = '';
    var tracks = videoInfo ? videoInfo.audio_tracks : self.player.get('audioTrackList');

    try {
      if (typeof id === 'string') {
        id = parseInt(id);
      }
    } catch (error) {
      id = 0;
    }

    if (tracks && tracks.length > 0) {
      for (var i = 0, l = tracks.length; i < l; ++i) {
        if (tracks[i].id == id) {
          result = tracks[i].lang;
          break;
        }
      }
    }
    return result;
  }

  function compareContentType(info, type) {
    return Boolean(info) && typeof info.content_type === 'string' && info.content_type.includes(type);
  }

}

MggpPluginVodChannels.prototype = Object.create(MggpPlugin.prototype);
MggpPluginVodChannels.prototype.constructor = MggpPluginVodChannels;

module.exports = MggpPluginVodChannels;

function modifyStreamForRequiredSubs(stream) {
  const { audio_tracks: audioTracks, subtitles } = stream;
  const tracksWithRequired = audioTracks.filter((at) => at.require_subtitles);
  let tracksToRemove = [];
  if (subtitles.length === 0) {
    tracksToRemove = tracksWithRequired.map((t) => t.id);
  } else if (subtitles.length === 1) {
    const [s] = subtitles;
    tracksWithRequired.forEach((track) => {
      if (s.lang === track.lang) {
        tracksToRemove.push(track.id);
      }
    });
  }

  const newStream = Object.assign({}, stream);
  if (tracksToRemove.length > 0) {
    newStream.audio_tracks = audioTracks.filter((at) => !tracksToRemove.includes(at.id));
  }
  return newStream;
};
